import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export const useAiThinkingParts = (): boolean => {
  const user = useUser();
  return useFliptBoolean("ai-thinking-parts", false, user?.email);
};

export default useAiThinkingParts;
